module.exports = __webpack_public_path__ + "img/pistol.python.ebe0f0b0.png";